// UnitMask values + kfUnit* unit-state flags — game/ht.h:5530-5580 + 6667-6674.

import {
  kutShortRangeInfantry,
  kutLongRangeInfantry,
  kutTakeoverSpecialist,
  kutAndy,
  kutFox,
  kutGalaxMiner,
  kutLightTank,
  kutMediumTank,
  kutMachineGunVehicle,
  kutRocketVehicle,
  kutMobileHeadquarters,
  kutArtillery,
  kutHumanResourceCenter,
  kutReactor,
  kutProcessor,
  kutHeadquarters,
  kutResearchCenter,
  kutVehicleTransportStation,
  kutRadar,
  kutWarehouse,
  kutReplicator,
  kutMachineGunTower,
  kutRocketTower,
} from './side.ts';

export const kumShortRangeInfantry = 1 << kutShortRangeInfantry;
export const kumLongRangeInfantry = 1 << kutLongRangeInfantry;
export const kumTakeoverSpecialist = 1 << kutTakeoverSpecialist;
export const kumAndy = 1 << kutAndy;
export const kumFox = 1 << kutFox;
export const kumInfantry =
  kumShortRangeInfantry | kumLongRangeInfantry | kumTakeoverSpecialist | kumAndy | kumFox;

export const kumGalaxMiner = 1 << kutGalaxMiner;
export const kumLightTank = 1 << kutLightTank;
export const kumMediumTank = 1 << kutMediumTank;
export const kumMachineGunVehicle = 1 << kutMachineGunVehicle;
export const kumRocketVehicle = 1 << kutRocketVehicle;
export const kumMobileHeadquarters = 1 << kutMobileHeadquarters;
export const kumArtillery = 1 << kutArtillery;
export const kumVehicles =
  kumGalaxMiner |
  kumLightTank |
  kumMediumTank |
  kumMachineGunVehicle |
  kumRocketVehicle |
  kumMobileHeadquarters |
  kumArtillery;
export const kumMobileUnits = kumInfantry | kumVehicles;

export const kumHumanResourceCenter = 1 << kutHumanResourceCenter;
export const kumReactor = 1 << kutReactor;
export const kumProcessor = 1 << kutProcessor;
export const kumHeadquarters = 1 << kutHeadquarters;
export const kumResearchCenter = 1 << kutResearchCenter;
export const kumVehicleTransportStation = 1 << kutVehicleTransportStation;
export const kumRadar = 1 << kutRadar;
export const kumWarehouse = 1 << kutWarehouse;
export const kumReplicator = 1 << kutReplicator;

export const kumMachineGunTower = 1 << kutMachineGunTower;
export const kumRocketTower = 1 << kutRocketTower;
export const kumTowers = kumMachineGunTower | kumRocketTower;

export const kumStructures =
  kumHumanResourceCenter |
  kumReactor |
  kumProcessor |
  kumHeadquarters |
  kumResearchCenter |
  kumVehicleTransportStation |
  kumRadar |
  kumWarehouse |
  kumMachineGunTower |
  kumRocketTower |
  kumReplicator;

// NOTE: the Replicator is deliberately NOT a Builder (the BuildMgr must not use it)
export const kumBuilder = kumHeadquarters | kumVehicleTransportStation | kumHumanResourceCenter;
export const kumAll = (kumInfantry | kumVehicles | kumStructures) >>> 0;
export const kumImpossible = 0xffffffff;

// game/ht.h:6667-6674 — UnitGob m_wfUnit flags
export const kfUnitInvulnerable = 0x0001;
export const kfUnitDrawHealthIndicator = 0x0002;
export const kfUnitDrawRepairingSymbol = 0x0004;
export const kfUnitRepairing = 0x0008;
export const kfUnitDrawNeedsPowerSymbol = 0x0010;
export const kfUnitDrawNeedCreditsSymbol = 0x0020;
export const kfUnitNeedCredits = 0x0040;
export const kfUnitHilighted = 0x0080;

// game/ht.h:301-302
export const knIncreasedFirePowerPercent = 20;
export const knIncreasedMinerLoadValuePercent = 20;

// game/ht.h:273-284 — performance options. PINNED SIM CONSTANTS in the port
// (ctx.wfPerfOptions defaults to kfPerfMax; the MP lobby forces it — perf-gated sync-RNG
// sites in Struct.cpp/LRInfantry.cpp desync otherwise).
export const kfPerfRocketShots = 0x0001;
export const kfPerfRocketTrails = 0x0002;
export const kfPerfRocketImpacts = 0x0004;
export const kfPerfShots = 0x0008;
export const kfPerfShotImpacts = 0x0010;
export const kfPerfSelectionBrackets = 0x0020;
export const kfPerfSmoke = 0x0040;
export const kfPerfEnemyDamageIndicator = 0x0080;
export const kfPerfScorchMarks = 0x0100;
export const kfPerfSymbolFlashing = 0x0200;
export const kfPerfAll = 0x03ff;
export const kfPerfMax = 0xffff;
